import { Button, Col, Icon, Input, Row, Upload } from "antd";
import Form, { FormComponentProps } from "antd/lib/form";
import { UploadChangeParam, UploadFile } from "antd/lib/upload/interface";
import IFilterSelectOption from "components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption";
import FormControl from "components/Forms/FormControl";
import SimpleSelect from "components/Forms/SimpleSelect";
import { ButtonColLayout } from "components/UserManagement/Profile/UpdateUserProfileForm/UpdateUserProfileForm.Style";
import Utility from "Core/Utility";
import ValidationUtility from "Core/ValidationUtility";
import * as React from "react";
import { BolFileModel } from "../BolFilesEditor";
import { TrackedBolFileHandler } from "./TrackedBolFileHandler";

export interface Props extends FormComponentProps {
    children?: React.ReactNode,
    onFileAdded?: (values: BolFileModel) => void;
    onCancel?: Function;
    fileTypes?: IFilterSelectOption[];
}

export interface State {
    fileTypes?: IFilterSelectOption[];
}

export class UploadFileFormWithoutForm extends React.Component<Props, State> {
    handler: TrackedBolFileHandler;

    constructor(props: Props) {
        super(props)

        this.state = {
        }
        this.handler = new TrackedBolFileHandler(props);
    }

    componentDidMount = () => {
        if (!this.props.fileTypes) {
            this.getTrackedBolFileTypes();
        }
    }

    onCancel = () => {
        this.props.onCancel?.call(this);
    }

    getTrackedBolFileTypes = () => {
        this.handler.GetBolFileTypes().then(x => {
            const fileTypes: IFilterSelectOption[] =
                x.results?.map(y => ({
                    text: y.name!,
                    value: y.id!,
                })) ?? [];
            this.setState({ fileTypes });
        })
    }

    getBase64(file): Promise<string | ArrayBuffer | null> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file.file ?? file?.FileList[0]?.originFileObj ?? file.file.originFileObj);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    onSubmit = (event: React.SyntheticEvent) => {
        event.preventDefault();
        event.stopPropagation();

        this.props.form.validateFieldsAndScroll((errors, values: { name: string, bolFileTypeId: string, file: UploadChangeParam }) => {
            if (errors) return;
            // convert the file to a base64 string.
            this.getBase64(values.file).then(x => {
                let update: BolFileModel;

                update = {
                    data: x as string,
                    bolFileTypeId: values.bolFileTypeId,
                    name: values.file.file.name,
                };

                this.props.onFileAdded?.call(this, update);
            })
        });

    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form onSubmit={x => x.preventDefault() == Utility.voidmethod() && this.onSubmit(x)}>
                <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[
                        ...ValidationUtility.getRequired('Please select a File Type'),
                    ]}
                    name="bolFileTypeId"
                    label="File Type">
                    <SimpleSelect options={this.props.fileTypes ? this.props.fileTypes : this.state.fileTypes} />
                </FormControl>

                <FormControl
                    getFieldDecorator={getFieldDecorator}
                    rules={[
                        ...ValidationUtility.getRequired('Please select a file'),
                    ]}
                    name="file"
                    label="File">
                    <Upload accept=".pdf,.xls,.xlsx,.doc,.docx,.jpeg,.jpg,.png" beforeUpload={() => false} multiple={false} >
                        <Button>
                            <Icon type="upload" /> Browse
                        </Button>
                    </Upload>
                </FormControl>
                <Row>
                    <Col>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Upload
                            </Button>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item>
                            <Button onClick={this.onCancel}>
                                Cancel
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        )
    }
}

const UploadFileForm = Form.create<Props>({
    name: 'UploadFileForm',
})(UploadFileFormWithoutForm);

export default UploadFileForm;